<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <div class="row mt-4">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">{{(isEdit) ? 'Edit' : 'Add'}} Useful Link</h3>
            </div>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              enctype="multipart/form-data"
              class="body-content"
            >
              <v-row>
                <v-col cols="12">
                  <label class="form-control-label">
                    Title
                    <span class="red--text">*</span>
                  </label>
                   <v-textarea
                    v-model="usefulLink.title"
                    solo
                    label="Enter Title"
                    auto-grow
                    :rules="[(v) => !!v || 'Title is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                    rows="5"
                  ></v-textarea>
                </v-col>

                <v-col cols="12">
                  <label class="form-control-label">
                    URL
                    <span class="red--text">*</span>
                  </label>
                  <v-text-field
                    v-model="usefulLink.url"
                    placeholder="Enter Link"
                    :rules="rules"
                    required
                    solo
                  ></v-text-field>
                </v-col>

                <v-col class="text-right" cols="12">
                  <v-btn
                    color="#989898"
                    class="mr-4 white--text"
                    @click="cancel"
                    >Cancel</v-btn
                  >
                  <v-btn
                    v-if="!isEdit"
                    :disabled="!valid"
                    :loading="loading"
                    color="#344452"
                    class="white--text"
                    @click="save"
                    >Save</v-btn
                  >
                  <v-btn
                    v-if="isEdit"
                    :disabled="!valid"
                    :loading="loading"
                    color="#344452"
                    class="white--text"
                    @click="update"
                    >Update</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonSection from "@/components/CommonHeader";
import { usefullinkService } from "@/services";

export default {
  name: "Add Useful Link",
  components: {
    CommonSection,
  },
  data() {
    return {
      loading: false,
      valid: true,
      usefulLink: {
        title: null,
        url: null,
      },
      isEdit :  false,
      rules: [
        (value) => !!value || "URL is Required.",
        (v) => v && !!v.trim() || 'Field cannot be blank',
        (v) =>
          !v ||
          /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/.test(
            v
          ) ||
          "URL is not valid.",
      ],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      if (this.$route.params.id !== 'create') {
        const usefulLink = await usefullinkService.get(this.$route.params.id);
        this.usefulLink.title = usefulLink.data.data[0].title;
        this.usefulLink.url = usefulLink.data.data[0].url;
        this.isEdit = true;
      } 
    },
    cancel() {
      this.$router.push("/useful-links");
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          await usefullinkService.create(this.usefulLink);
          this.loading = false;
          this.$router.push("/useful-links");
          this.$store.dispatch("user/setSnack", "UseFul Link added successfully!");
          this.$store.dispatch("user/setType", "info");
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async update() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const response = await usefullinkService.update({
            id: this.$route.params.id,
            object: this.usefulLink,
          });
          this.loading = false;
          if (response) {
            this.$store.dispatch("user/setSnack", "Useful Links updated successfully!");
            this.$store.dispatch("user/setType", "info");
            this.$router.push("/useful-links");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.main-content .navbar-top {
  display: none !important;
}

.body-content {
  padding: 40px !important;
}
</style>